/**
 * 服务资源树和本地路由匹配得到的最终结果菜单列表
 * date:2021-07-07 15:49
 * desc:传入的resourceData要为有效的资源树，黑名单等资源，请先移除后生成最终有效资源树数据在做匹配
 * 使用方式：
 * const routerList = getNewTreeMenu(RouterModules, platformName, resourceList, false);
 */

// 过滤掉菜单下，只有目录的资源
function filterSource(sourceList) {
  if (sourceList && sourceList.length) {
    return sourceList.filter((source) => {
      const { subList, resourceType } = source
      if (resourceType === 3) {
        // 目录类型
        if (subList && subList.length) {
          // 有子菜单
          const newList = filterSource(subList)
          if (newList && newList.length) {
            return {
              ...source,
              subList: newList,
            }
          } else return null
        } else {
          // 无子菜单
          return null
        }
      } else {
        // 非目录类型
        return source
      }
    })
  }
  return null
}

// 拼接路径
function splitRoutePath(parent, item) {
  if (!parent || !parent.path) return item.path
  const parentPath = parent.path
  const childPath = item.path
  const start =
    childPath.startsWith('/') ||
    childPath.startsWith('http://') ||
    childPath.startsWith('https://')
  if (start) return childPath
  return `${parentPath}/${childPath}`
}

// 打平本地路由
function getRouteDataMap(routerModules) {
  const routeData = [...(routerModules || [])] // 本地二级路由-一级
  const resultRoute = {}
  // eslint-disable-next-line no-shadow
  const getList = (routeData, parent) => {
    routeData.forEach((route) => {
      const { children = [], redirect, path, name } = route
      const itemObj = { ...route }
      itemObj.path = splitRoutePath(parent, route) // 绝对路径处理和相对路径拼接
      const noPermissionSub = children.filter((i) => {
        // noPermission ？？？
        return i.noPermission
      })
      // 本地
      if (
        redirect &&
        redirect !== 'noredirect' &&
        noPermissionSub &&
        noPermissionSub.length
      ) {
        for (const index in noPermissionSub) {
          const keyItem = noPermissionSub[index]
          const fullPath = `${path.replace(/\/+$/, '')}/${keyItem.path.replace(
            /^\/+/,
            '',
          )}`
          if (fullPath === redirect) {
            itemObj.isPage = true
            itemObj.redirectName = keyItem.name
            break
          }
        }
      }
      resultRoute[name] = itemObj
      if (children && children.length) {
        getList(children, itemObj) // 递归
      }
    })
  }
  getList(routeData)
  return resultRoute
}
function getSubMenuList(item, routeDataMap = {}, showHidden = false) {
  const { subList } = item || {}
  if (subList && subList.length) {
    const list = []
    const getList = (arr) => {
      arr.forEach((o) => {
        routeDataMap = routeDataMap || {}
        const oRouteItem = routeDataMap[o.resourceKey]
        if (
          o.resourceType !== 2 &&
          oRouteItem &&
          (showHidden || !oRouteItem.hidden)
        ) {
          list.push(o.resourceKey)
        }
        if (o.subList && o.subList.length) {
          getList(o.subList)
        }
      })
    }
    getList(subList || [])
    return list
  } else {
    return []
  }
}
function findIdRouterFunc(item, routeDataKeysName = {}, showHidden = false) {
  routeDataKeysName = routeDataKeysName || {}
  if (item.path) {
    // TODO:这个功能待定
    return item
  }
  const subList = getSubMenuList(item, routeDataKeysName, showHidden) || []
  let hasItem = false //  !!判断是否为子集，如果含有子集，应该以子集判断为主，如果没有子集，就是页面菜单，以菜单页面为主
  if (item.resourceType === 3 && subList && subList.length) {
    // 存在子级别的时候
    // eslint-disable-next-line no-shadow
    const subList = getSubMenuList(item, routeDataKeysName, showHidden) || []
    const currentItem = routeDataKeysName[item.resourceKey]
    if (currentItem && item.resourceType === 3) {
      const isHide = subList.every((citem) => {
        const cur = routeDataKeysName[citem]
        return cur && cur.hidden
      })
      if (isHide) {
        hasItem = currentItem
      }
    }
    if (!hasItem) {
      for (const i in subList) {
        if (
          routeDataKeysName[subList[i]] &&
          !routeDataKeysName[subList[i]].hidden
        ) {
          hasItem = routeDataKeysName[subList[i]]
          break
        }
      }
    }
  } else {
    // 是本身的时候判断是不是隐藏页面
    // 判断资源是不是在route找得到，找得到的话，是否是目录，如果都是目录，但是没有子集交叠就不展示；是页面才展示
    const currentItem = routeDataKeysName[item.resourceKey]
    if (currentItem && currentItem.isPage) {
      hasItem = routeDataKeysName[item.resourceKey]
    } else if (
      currentItem &&
      !(currentItem.children && currentItem.children.length)
    ) {
      hasItem = routeDataKeysName[item.resourceKey]
    }
  }
  return hasItem
}

// 生成树形结果菜单
function setNewTreeMenu(routerModules, resourceList, showHidden = false) {
  const routeDataKeysName = getRouteDataMap(routerModules) || {} // 本地路由按name处理 path
  const getItem = (item) => {
    const hasItem = findIdRouterFunc(item, routeDataKeysName, showHidden)
    if (!hasItem) {
      return false
    }
    const {
      resourceKey,
      subList,
      isFirst = 0,
      resourceName,
      cpFlag,
      resourceType,
      id,
    } = item || {}
    const newItem = {
      ...(routeDataKeysName[resourceKey] || {}),
      isFirst,
      resourceName,
      cpFlag,
      resourceKey,
      resourceType,
      id,
      component: null,
    }
    // newItem.parentFormat = [...(parent && parent.parentFormat || []), item.resourceKey];
    const toRouteItem = routeDataKeysName[resourceKey]
    if (toRouteItem && toRouteItem.hidden) {
      newItem.hidden = true
    } else if (
      toRouteItem &&
      toRouteItem.resourceType === 1 &&
      !(toRouteItem.children && toRouteItem.children.length)
    ) {
      newItem.isShowMenu = true
    } else if (
      toRouteItem &&
      toRouteItem.resourceType === 1 &&
      !toRouteItem.hidden &&
      toRouteItem.children &&
      toRouteItem.children.length
    ) {
      const isAllHidden = toRouteItem.children.every((citem) => citem.hidden)
      if (isAllHidden && toRouteItem.path) {
        newItem.isShowMenu = true
      }
    } else if (
      hasItem &&
      toRouteItem &&
      toRouteItem.resourceType === 3 &&
      hasItem.hidden
    ) {
      newItem.hidden = true
    }
    if (subList && subList.length) {
      const subMenuList = []
      subList.forEach((o) => {
        if (
          (o && o.resourceType === 1 && routeDataKeysName[o.resourceKey]) ||
          (o && o.resourceType === 3 && o.subList && o.subList.length)
        ) {
          subMenuList.push(o)
        }
        if (o && o.resourceType === 2 && o.subList && o.subList.length) {
          o.subList.map((p) => {
            return subMenuList.push(getItem(p, newItem))
          })
        }
      })
      const btnList = subList.filter((o) => {
        return o.resourceType === 2 || o.resourceType === 1
      })
      btnList && btnList.length && (newItem.btnList = btnList)
      if (subMenuList && subMenuList.length) {
        newItem.children = subMenuList
        newItem.subList = subMenuList
        let newSubMenuList = subMenuList.map((subItem) => {
          return getItem(subItem, newItem)
        })
        newSubMenuList = newSubMenuList.filter((o) => {
          return o
        })
        if (newSubMenuList && newSubMenuList.length) {
          newItem.children = newSubMenuList
          newItem.subList = newSubMenuList
        }
      }
    }
    return newItem
  }
  const newTree = resourceList.map((item) => {
    // 二级菜单处理
    return getItem(item)
  })
  const newResourceList = newTree.filter((o) => {
    return o
  })
  return newResourceList
}

// 获取微前端嵌入到其他平台的菜单
function getOtherSystemToCurrentMenu(data, platformKey) {
  const otherResourceList = (data || []).filter((o) => {
    return o.resourceKey !== platformKey
  })
  const list = []
  const getMenu = (resourceList) => {
    resourceList.forEach((v) => {
      if (v.isShow === 1 && v.resourceUrl !== '') {
        const slice = v.resourceUrl.slice(0, platformKey.length + 2)
        if (slice === `/${platformKey}/`) {
          list.push(v)
        }
      }
      if (Array.isArray(v.subList) && v.subList.length) {
        getMenu(v.subList)
      }
    })
  }
  getMenu(otherResourceList)
  return list
}

/**
 * @param {OriRouterModules} 平台路由列表
 * @param {platformKey} 平台sourceKey
 * @param {data} 服务返回菜单列表
 * @param {showHidden} showHidden
 * @returns
 */
export default function (
  OriRouterModules,
  platformKey,
  data,
  showHidden = false,
) {
  const routerModules = [...OriRouterModules]
  const resourceList = (data || []).filter((o) => {
    // 当前一级菜单-服务返回
    return o.resourceKey === platformKey
  })
  if (resourceList && resourceList.length) {
    // 获取微前端嵌入到其他平台的菜单
    const otherMenu = getOtherSystemToCurrentMenu(data, platformKey)
    if (otherMenu.length) {
      resourceList[0].subList = resourceList[0].subList.concat(otherMenu)
    }
    const result = filterSource(resourceList[0].subList)
    let nowSourceList = result || []
    nowSourceList = nowSourceList.map((item) => ({ ...item, isFirst: 1 })) // 二级菜单-一级
    return setNewTreeMenu(routerModules, nowSourceList, showHidden)
  } else {
    return false
  }
}
